"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import {
  registerNavigationHealthErrorHandlers,
  trackNavigationRendered,
} from "@/lib/analytics/navigationHealth";

const NavigationHealthMonitor = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    return registerNavigationHealthErrorHandlers();
  }, []);

  useEffect(() => {
    const query = searchParams?.toString();
    const url = query ? `${pathname}?${query}` : pathname;
    trackNavigationRendered(url || window.location.pathname);
  }, [pathname, searchParams]);

  return null;
};

export default NavigationHealthMonitor;